import React, { useState } from "react";
import { View, StyleSheet, Platform, Text } from "react-native";
import appStyles from "../../../../appStyles";
import Header from "../../../common/header/index";
import AccountMenuOptions from "../../common/AccountMenuOptions";
import appPages from "../../../../../appPages";
import Account from "./Account";
import SourceReceivedData from "../SourceReceivedData";
import AppTheme from "../../../AppTheme";
import IntegrationFabButton from "../IntegrationFabButton";

export default function AccountsList({
  controller,
  accounts,
  calendarType,
  autotrackKey,
  editAccount = () => {},
  toggleAccountStatus = () => {},
  disconnectAccount = () => {},
  connectNewAccount = () => {},
  goBack = () => {},
}) {
  const [selectedAccount, setSelectedAccount] = useState(null);
  const isGoogleCal = calendarType == "calendar_google";
  const integrationsRef = React.createRef();

  return (
    <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
      <Header
        title={isGoogleCal ? "Google Calendar" : "Calendar"}
        subTitle={`${accounts.length} account${
          accounts.length == 1 ? "" : "s"
        } connected`}
        goBack={goBack}
        returnPage={appPages.integrationsV2}
      />

      <View style={{ flex: 1 }}>
        <Text style={styles.headerText}>Accounts connected</Text>

        {accounts.map((a, index) => (
          <Account
            controller={controller}
            key={index}
            account={a}
            editAccount={editAccount}
            toggleAccountStatus={toggleAccountStatus}
            onLongPress={() => setSelectedAccount(a)}
          />
        ))}

        <Text style={styles.linkText} onPress={connectNewAccount}>
          Add another calendar account
        </Text>

        {/* All data */}
        <SourceReceivedData
          ref={integrationsRef}
          controller={controller}
          sourceName={calendarType}
        />
      </View>

      <IntegrationFabButton
        connectNewAccount={connectNewAccount}
        refresh={() => {
          controller.getItems();
          integrationsRef.current.loadData();
        }}
      />

      <AccountMenuOptions
        controller={controller}
        account={selectedAccount}
        accounts={accounts}
        disconnectAccount={disconnectAccount}
        close={() => setSelectedAccount(null)}
        integrationName={autotrackKey}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  headerText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#8B92A1",
    marginBottom: 4,
    paddingLeft: 6,
  },
  linkText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
    width: "100%",
    textAlign: "center",
    marginTop: 20,
    marginBottom: 20,
  },
});
